// 配置API接口地址
var root = process.env.API_ROOT;
// 引用axios
var axios = require("axios");

import router from "../router";

import Toast from "vant/lib/toast";
import "vant/lib/toast/style";

// import that from 'vue-router';
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}

axios.defaults.retry = 4;
axios.defaults.retryDelay = 3000;

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return axios(config);
  });
});

function apiAxios(method, url, params, ifwhole, success, failure) {
  if (params) {
    params = filterNull(params);
  }
  axios({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null,
    baseURL: root,
    headers: { "Content-Type": "application/json; charset=utf-8" },
    withCredentials: false,
  })
    .then(function (res) {
      if (res.data.code === -400) {
        Toast(res.data.msg);
        // let redirect = window.location.href.slice(window.location.href.indexOf("/#") + 2, window.location.href.length)
        // router.push({
        // 	path: '/signIn',
        // 	query: {
        // 		redirect: redirect
        // 	}
        // })
        noToken();
      } else {
        if (ifwhole) {
          success(res);
        } else {
          if (res.data.code === 1) {
            success(res.data);
          } else {
            if (failure) {
              failure(res.data);
            } else {
              Toast(res.data.msg);
            }
          }
        }
      }
    })
    .catch(function (err) {
      let res = err.response;
      if (err) {
        if (res.data.code == 401) {
          noToken();
          // let redirect = window.location.href.slice(window.location.href.indexOf("/#") + 2, window.location.href.length)
          // router.push({
          // 	path: '/signIn',
          // 	query: {
          // 		redirect: redirect
          // 	}
          // })
        } else if (res.status == 404) {
          Toast("亲，网络开小差了~~~");
        } else {
          console.log(err);
        }

        return;
      }
    });
}
function noToken() {
  // let is = window.location.href.indexOf("/#")
  // let is2 = window.location.href.indexOf("#/")
  // let num = is + 2
  // if (is === -1) {
  //   num = is2 + 1
  // }
  // let redirect = window.location.href.slice(num, window.location.href.length)
  let redirect = window.location.href.split("/#")[1];
  router.push({
    path: "/signIn",
    query: {
      redirect,
    },
  });
}
// 返回在vue模板中的调用接口
export default {
  get: function (url, params, ifwhole, success, failure) {
    return apiAxios("GET", url, params, ifwhole, success, failure);
  },
  post: function (url, params, ifwhole, success, failure) {
    return apiAxios("POST", url, params, ifwhole, success, failure);
  },
  put: function (url, params, ifwhole, success, failure) {
    return apiAxios("PUT", url, params, ifwhole, success, failure);
  },
  delete: function (url, params, ifwhole, success, failure) {
    return apiAxios("DELETE", url, params, ifwhole, success, failure);
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js